// extracted by mini-css-extract-plugin
export default {"privacy-policy-text-wrapper":"styles_privacy-policy-text-wrapper__0Z8u3","privacy-policy-text":"styles_privacy-policy-text__I4kDe"};